// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1VJs4","col":"styles_col__36mSl"};